import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <>
      <Helmet>
        <title>Page Not Found | Tech Zone FZC</title>
        <meta name="description" content="The page you're looking for doesn't exist. Tech Zone FZC - IT Products & Services Dubai, UAE" />
      </Helmet>

      <section className="pt-60 pb-60" style={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div className="container text-center">
          <div style={{ fontSize: '120px', fontWeight: 'bold', color: '#D4AF37', marginBottom: '20px' }}>404</div>
          <h2 style={{ fontSize: '36px', marginBottom: '20px' }}>Page Not Found</h2>
          <p style={{ fontSize: '18px', marginBottom: '30px', color: '#666' }}>
            Sorry, the page you are looking for doesn't exist or has been moved.
          </p>
          <Link to="/" className="btn-common primary-btn global-btn-style">
            <span>Back to Home</span>
          </Link>
        </div>
      </section>
    </>
  );
}
